import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getCheckListAvailableColumns } from './api';

export const path = '/ork/checklist';

const PageOrkCheckList: React.FC = (props) => {
  const OrkCheckList = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      columns: getCheckListAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <OrkCheckList {...props} />;
};

export default PageOrkCheckList;
